<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <label class="form-label">{{ _t('Answer') }}</label>
                <input disabled v-model="text" type="text"  class="form-control"/>
            </div>
            <div class="col-lg-3 col-md-6">
                <label for="sortOrder" class="form-label">{{ _t('Sort order') }}</label>
                <input disabled v-model="sortOrder" type="number" id="sortOrder" class="form-control"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShowAnswer",
    props: [
        'text',
        'sortOrder'
    ],
    methods: {

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/ShowAnswer.vue